module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main-layout', [_c('section', {
    staticClass: "content",
    attrs: {
      "role": "main",
      "aria-label": "תוכן",
      "id": "RhythmAudition"
    }
  }, [_c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "info-content"
  }, [_c('div', {
    staticClass: "fill"
  }, [_c('img', {
    key: _vm.img2srcD,
    staticClass: "fillImgFront",
    attrs: {
      "src": "photos/rhythm/pic01.jpg",
      "alt": "איך מצטרפים?"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "textbox-bounds textbox-bounds-unbound-double"
  }, [_c('div', {
    staticClass: "textbox-tab-mark"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "origamiform",
      "data-origamiformname": "form_60535b7a703b5",
      "data-origamiformid": "7f13ea0dcf451dcaaa3a1302797f1cf73571e4fd4c3dbd53097cba8fc7bd5557d48ab4a8aabbd10df91b7f5f9ab46b85d53f3df28bd8c1a66432f41c980e4c02Bo4z7mwvaX+7php4gfaAkz/HS12o6SAabt95wTMplVjY5gr3a1ABECPM4sPNnhxvF6RL1ObY8dTMLHLDXRMNv81yi9qaDJ/4B24mw5S92M5R9HS1LIFLysWJ5S9QfypW"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "textbox-text"
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "divider",
    attrs: {
      "id": "FAQSdivider"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2b30d3d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/EnsambleManual.vue
// module id = 110
// module chunks = 0